import { render, staticRenderFns } from "./RevenueData.vue?vue&type=template&id=ddc8d13a"
import script from "./RevenueData.vue?vue&type=script&lang=js"
export * from "./RevenueData.vue?vue&type=script&lang=js"
import style0 from "./RevenueData.vue?vue&type=style&index=0&id=ddc8d13a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RevenueData.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports